import React from 'react';
import { DayPass, Cabana, SpaPass, Daybed, Fitness } from './icons';

export const getIconByProductType = type => {
  switch (Number(type)) {
    case 0:
      return <DayPass />;
    case 1:
      return <Cabana />;
    case 2:
      return <SpaPass />;
    case 3:
      return <Daybed />;
    case 4:
    case 5:
    case 6:
      return <Fitness />;
    default:
      return <DayPass />;
  }
};
